import { useParams } from 'react-router-dom';

import { AppWPPlaylistsPage } from '~/components/pages/AppWPPlaylistsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppWPPlaylistsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppWPPlaylistsPage appId={appId} />
    </DashboardTemplate>
  );
};
